import { UserManager, OidcClient, OidcClientSettingsStore, MetadataService } from "oidc-client-ts";
import LocalStorageUtil from "../localStorage/LocalStorageUtil.js";
class CachedMetadataService extends MetadataService {
  constructor(settings) {
    super(settings);
    this.metadata = null;
    this.localStoreKey = {
      key: `OidcClientMetadata_${settings.authority}`,
      pathIndependant: true,
      ttl: { days: 5 },
      userIndependant: true
    };
  }
  async getMetadata() {
    if (this.metadata) {
      return this.metadata;
    }
    let newMetaData = LocalStorageUtil.get(this.localStoreKey, null);
    if (!newMetaData) {
      newMetaData = await super.getMetadata();
      this.metadata = newMetaData;
      LocalStorageUtil.set(this.localStoreKey, newMetaData);
    }
    return newMetaData;
  }
}
class CachedOidcClient extends OidcClient {
  constructor(settings) {
    const settingsStore = new OidcClientSettingsStore(settings);
    super(settingsStore, new CachedMetadataService(settingsStore));
  }
}
class UserManagerWithMetadataCache extends UserManager {
  constructor(settings) {
    super(settings);
    this._client = new CachedOidcClient(settings);
  }
}
export {
  UserManagerWithMetadataCache as default
};
//# sourceMappingURL=UserManagerWithMetadataCache.js.map
